import React from 'react';

import './loading.css';

export default (props) =>
  <div className={`loadingWrapper ${props.fullScreen}`}><div className="lds-ripple"><div></div><div></div></div></div>
